import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

@Component({
  selector: 'bm-link-cell',
  templateUrl: './link-cell.component.html',
  styleUrls: ['./link-cell.component.scss']
})
export class LinkCellComponent implements ICellRendererAngularComp {

  constructor() { }

  cellValue: any;

  agInit({value}) {
    this.cellValue = value;
  }

  refresh({value}) {
    this.cellValue = value;
    return true;
  }

}
